import 'owl.carousel';

const $el = $('.js-insurance-types');

$el.owlCarousel({
    loop: false,
    dots: false,
    mouseDrag: true,
    nav: true,
    navText: [],
    responsive: {
        0: {
            center: true,
            items: 1
        },
        700: {
            items: 2
        },
        1000: {
            items: 3
        },
        1500: {
            items: 4
        }
    },
});